import { render, staticRenderFns } from "./ReleaseNoteGroup.vue?vue&type=template&id=fae4285c&scoped=true&"
import script from "./ReleaseNoteGroup.vue?vue&type=script&lang=js&"
export * from "./ReleaseNoteGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fae4285c",
  null
  
)

export default component.exports